<template>
<div class="container">
  <Card>
<!--    <div>-->
<!--      <Breadcrumb>-->
<!--        <BreadcrumbItem to="/">首页</BreadcrumbItem>-->
<!--        <BreadcrumbItem>选择门票</BreadcrumbItem>-->
<!--      </Breadcrumb>-->
<!--    </div>-->
    <SaleStep :current="current"></SaleStep>
    <div class="ticket-list">
      <x-table :columns="columns" :data="data"></x-table>
    </div>
  </Card>
</div>
</template>

<script>
import Vue from 'vue'
import { httpAction } from '@/api/manage'
import api from '@/api'
import SaleStep from '@/components/saleStep/Index'
import xTable from '@/components/xTable/index'
export default {
  name: 'purchase-list',
  components: {
    // calendar,
    SaleStep,
    'x-table': xTable
  },
  data () {
    return {
      columns: [
        {
          title: '门票名称',
          key: 'displayName',
          slot: 'displayName',
          tree: true
        },
        {
          title: '门票简述',
          key: 'summary',
          slot: 'summary',
        },
        {
          title: '单价',
          width: 150,
          key: 'salePrice',
          slot: 'salePrice',
        },
        {
          title: ' ',
          slot: 'action',
          key: 'action',
          width: 150,
          align: 'center'
        }
      ],
      data: [],
      ticketList: [],
      // url: {
      //   list: '/openapi/ticket/list'
      // },
      season: '',
      current: 0,
      needKnowShow: false,
      description: ''
    }
  },
  mounted () {
    // 淡旺季切换beigin
    this.season = this.$route.query.season
    // 淡旺季切换end
    this.getTicketList()
    this.ticketCodes = JSON.parse(window.localStorage.getItem('ticketCodes'))
  },
  methods: {
    handleClass(row, index) {
      console.log(row, index)
      let str = ''
      if (row && row.children) {
        str = 'parent-row'
      } else {
        str = 'children-row'
      }
      return str
    },
    handlePrice (data) {
      let str = ''
      //￥
      let dataC = JSON.parse(JSON.stringify(data))
      if (dataC.children) {
        let arr = dataC.children.sort((a, b) => {
          return a.salePrice * 1 - b.salePrice * 1
        })
        str = `${arr[0].salePrice}`
      } else {
        str = `${dataC.salePrice}`
      }
      return str
    },
    async getTicketList () {
      const obj = {
        isShowSightTicket: true, // 是否展示景点票
        attrType: 'SCOPE', // 不展示的属性类别（门、联、景），必传
        ticketKindType: 'general', // 票种类型，必传
        attrKey: 'sight' // 不展示的属性key(景点票)，必传

      }
      const res = await httpAction(api.ticketList, 'post', obj)
      console.log(res.data.productInfos)
      try {
        // let data = res.data.productInfos
        //  淡旺季切换begin
        let allSeasonTicketList = res.data.productInfos
        for (let ticket of allSeasonTicketList){
         for(let tiketAttr of ticket.attrInfos){ 
          if(tiketAttr.friendlyName == "DWJ"){
            if(tiketAttr.key == this.season || tiketAttr.key == 'QJ'){
              this.ticketList.push(ticket)
              }
              break;
            }
          }
        }
        //过滤
        let data = this.ticketList;//realData
        //  淡旺季切换end

        let arr = {}
        data.forEach(item => {
          // let ticketAttrs = item.ticketAttrs
          let ticketAttrs = item.attrInfos
          let obj = {}
          ticketAttrs.forEach(ticketAttr => {
            obj[ticketAttr.friendlyName] = ticketAttr
          })
          // if (obj['SCOPE'].key === 'gate') {
          // console.log(`香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`)
            if (arr[`香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`]) {
              arr[`香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`].children.push(item)
            } else {
              if(this.ticketCodes){
                // console.log(this.ticketCodes)
                for(let ticket of this.ticketCodes){
                  if(item.productSn == ticket.ticketCode){
                    // console.log(item.sn)
                    // ${ticket.attrValueName}
                    arr[`香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`] = {
                      id: `香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`,
                      displayName:`${ticket.attrValueName}`,
                      // displayName: `香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`,
                      // displayName: `${obj['BELONG_SIG'].value}`,
                      summary: '',
                      salePrice: '',
                      isOpen: false,
                      children: [
                        item
                      ]
                    }
                  }
                }
                
              }else{
                arr[`香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`] = {
                id: `香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`,
                displayName: `香山公园${obj['DWJ'].value}${obj['SCOPE'].value}`,
                // displayName: `${obj['BELONG_SIG'].value}`,
                summary: '',
                salePrice: '',
                isOpen: false,
                children: [
                  item
                ]
              }
              }
              
            }
          // }
        })
        // this.data = res.data.tickets
        this.data = Object.values(arr)
        console.log(this.data)
      } catch (e) {
        console.log(e)
      }
    },
    show (row, index) {
      // Vue.ls.remove('productId')
      // Vue.ls.set('productId', row.productId)
      const type = Vue.ls.get('type')
      if (type === '1') {
        // this.$router.push('/purchase/group')
        this.$router.push({ path: '/purchase/group', query: { id: row.productId } })
      } else {
        // this.$router.push('/purchase/individual')
        this.$router.push({ path: '/purchase/individual', query: { id: row.productId } })
      }
    }
  }
}
</script>

<style>
/* .ivu-table-header th{
  background-color: #E6D9D8;
  color:#bb1818;
} */
.ticket-table .ivu-table-cell div {
  display: inline-block;
}
.ticket-table th {
  background-color: #ED7357!important;
  color: #fff;
  padding: 12px 0!important;
}
</style>

<style scoped>
.container{
  margin-top:20px
}
.ticket-list{
  margin-top: 20px;
  padding: 20px;
}
  .x-text-btn{
    color: #ED7457;
    background: transparent !important;
    border: none;
    box-shadow: none;
    padding: 0;
  }
</style>